import React from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { handleChange } from "presentation/utils/functions/generic";
import PageLoadingIndicator from "presentation/components/page-loading-indicator";
import PageAlert from "presentation/components/page-alert";

import reportsService from "presentation/services/reports";

import { saveAs } from 'file-saver';
import { reportTypes } from "presentation/model/constants";

class DisciplineAttendancesReportFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filterForm: {
        classroomId: null,
        activityId: null,
        disciplineId: null
      },
      loading: false,
      actionLoading: false,
      error: false,
      message: '',
      activities: [],
      data: [],
      resultsData: [],
      activityData: []
    };
  }

  toPDF = async () => {
    const { academicPeriodId } = this.props;
    let { filterForm } = this.state;
    let { classroomId, disciplineId, startDate, endDate } = filterForm;

    this.setState({ loading: true });

    var response = await reportsService.generatePDF({ reportType: reportTypes.DisciplineAttendance, entityId: parseInt(classroomId), academicPeriodId: academicPeriodId, disciplineId: disciplineId, startPeriod: startDate, endPeriod: endDate });
    if (response.error === true) {
      this.setState({ error: true, message: 'Erro ao tentar emitir o relatório em pdf...' });
    } else {
      var blob = new Blob([response]);
      saveAs(blob, 'report.pdf');
    }

    this.setState({ loading: false });
  };

  render() {

    const { disciplines, classrooms } = this.props;
    const { loading, actionLoading, error, message, filterForm } = this.state;

    const { toPDF } = this;
    var actionDisabled = loading || actionLoading;
    return (
      <div>
        {loading === true && <PageLoadingIndicator loadingText={actionLoading ? "Por favor, aguarde..." : "Carregando informações..."} />}
        {loading === false && error === true && <PageAlert className="m-b-20" message={"Erro"} description={message} type="danger" />}
        {loading === false && (
          <Container>
            <Row className="mt-4">
              <Col>
                <h3>Turma</h3>
                <Form.Select
                  aria-label="Turma"
                  id={`classroomId`}
                  name={`classroomId`}
                  onChange={(e) => handleChange(e, this, 'filterForm')}
                  value={filterForm.classroomId || undefined}
                  data-field-name="classroomId"
                >
                  {classrooms.map((e, i) => { return <option key={e.name} value={e.id}>{e.name}</option> })}
                </Form.Select>
              </Col>
              <Col>
                <h3>Disciplina</h3>
                <Form.Select
                  aria-label="Disciplina"
                  id={`disciplineId`}
                  name={`disciplineId`}
                  onChange={(e) => handleChange(e, this, 'filterForm')}
                  value={filterForm.disciplineId || undefined}
                  data-field-name="disciplineId"
                >
                  {disciplines.map((e, i) => { return <option key={e.name} value={e.id}>{e.name}</option> })}
                </Form.Select>
              </Col>
            </Row>
            <Row className="mt-4">
              <h3>Dia letivo</h3>
              <Col>
                <Row>
                  <Col size={6}>
                    <Form.Label htmlFor="startDate">Data de início</Form.Label>
                    <Form.Control
                      type="date"
                      id="startDate"
                      name="startDate"
                      defaultValue={filterForm.startDate}
                      onChange={(e) => handleChange(e, this, 'filterForm')}
                      aria-describedby="startDateHelpBlock"
                    />
                  </Col>
                  <Col size={6}>
                    <Form.Label htmlFor="endDate">Data fim</Form.Label>
                    <Form.Control
                      type="date"
                      id="endDate"
                      name="endDate"
                      defaultValue={filterForm.endDate}
                      onChange={(e) => handleChange(e, this, 'filterForm')}
                      aria-describedby="endDateHelpBlock"
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col className="mt-4">
                <Button variant="outline-success" onClick={() => toPDF()} disabled={actionDisabled} className={`m-l-1 float-end${actionDisabled == true ? ' disabled' : ''}`}>Emitir PDF</Button>
              </Col>
            </Row>
          </Container>
        )}
      </div>
    );
  };
}

export default DisciplineAttendancesReportFilter;
